import { favouritesAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { CreateListResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';
import { getAuthenticationConfig } from '../../utils/getAuthenticationConfig';

export const createList = async (name?: string) => {
  const path = endpointReplace({ ':siteType': SiteTypes.FAVOURITES }, Endpoints.Lists);
  const authentication = await getAuthenticationConfig();

  const response = await network.post<CreateListResponse>(
    path,
    {
      name: name,
    },
    authentication,
  );

  return response.data;
};
